import { useDispatch, useSelector } from "react-redux";
import { Radio } from "@rmwc/radio";
import { gaugeChange } from "../../../action/building_component/buildingComponent.action";
import CurrencyFormat from "react-currency-format";

const GaugeSetting = () => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	return (
		<div className="form-group col-auto">
			<div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
				<label className="control-label">Gauge</label>
				<span style={{ position: "unset" }} className={const_var.is_loader == true ? "active saving-effect saving-effect-type-2 border-radius-none" : "saving-effect saving-effect-type-2"}></span>
			</div>
			{const_var?.a_p_d_a?.base?.map((item, index) => {
				return (
					<div className="radio-group">
						<Radio
							label={item?.gauge_name}
							value={params.gauge_val}
							name={"gauge" + index}
							checked={params.gauge_val == item.gauge ? true : false}
							onChange={() => dispatch(gaugeChange(Number(item.gauge)))}
						/>
						{params.gauge_val == 14 && params.gauge_val == item.gauge && params.m_s_n == 169 && <span className="additional-info ml-1">(2x3 Framing)</span>}
						<div className={const_var.showGaugePrice == true && item.gauge != 14 && params.gauge_val == 12 ? "price-box-type-2" : "price-box-type-2 d-none"}>
							{const_var.hide_price_calculation != 1 && const_var.loginSession == false && <CurrencyFormat value={const_var.showGaugePriceVal} displayType={"text"} thousandSeparator={true} prefix={"$"} />}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default GaugeSetting;
